import { render, staticRenderFns } from "./PDLI2.vue?vue&type=template&id=4d4cb5a2&scoped=true&"
import script from "./PDLI2.vue?vue&type=script&lang=js&"
export * from "./PDLI2.vue?vue&type=script&lang=js&"
import style0 from "./PDLI2.vue?vue&type=style&index=0&id=4d4cb5a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4cb5a2",
  null
  
)

export default component.exports